import { type MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { useState } from "react";
import andreSquared from "#app/routes/_marketing+/images/andre_casal_squared.webp";
import signatureBlack from "#app/routes/_marketing+/images/signature-black.webp";
import signatureWhite from "#app/routes/_marketing+/images/signature-white.webp";
import { Icon } from "#app/ui/components/custom/icon.js";
import { Container } from "#app/ui/components/verveui/layout/container.js";

export const meta: MetaFunction = () => {
  return [
    { title: "Pagamento Confirmado — Estuda Comigo" },
    { name: "robots", content: "noindex" },
  ];
};

const PREPARE_URL = "https://estuda-comigo.com/preparar";

const Route = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    void navigator.clipboard.writeText(PREPARE_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container className="py-16 sm:py-24">
      <div className="mx-auto max-w-md">
        <div className="rounded-2xl border border-muted-200 bg-white p-8 shadow-lg dark:border-muted-800 dark:bg-muted-950 sm:p-10">
          <div className="text-center">
            <div
              className="mx-auto mb-6 flex shrink-0 items-center justify-center rounded-full"
              style={{ backgroundColor: "#dcfce7", width: 64, height: 64 }}
            >
              <Icon
                name="check"
                className="h-8 w-8 shrink-0"
                style={{ color: "#16a34a" }}
              />
            </div>

            <h1 className="text-2xl font-bold tracking-tight text-muted-900 sm:text-3xl">
              Pagamento confirmado
            </h1>

            <p className="mt-3 text-muted-500">
              Está tudo tratado. Quando estiveres pronto/a, prepara o teu
              ambiente de trabalho para a primeira sessão.
            </p>
          </div>

          <div className="mt-8 flex items-center gap-4 rounded-xl bg-muted-50 p-4 dark:bg-muted-900">
            <img
              src={andreSquared}
              alt="André Casal"
              className="h-12 w-12 flex-shrink-0 rounded-full border-2 border-white object-cover shadow-sm dark:border-muted-800"
            />
            <div>
              <p className="font-semibold text-muted-900">André Casal</p>
              <p className="text-sm text-muted-500">O teu professor</p>
            </div>
          </div>

          <Link
            to="/preparar"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl border border-brand bg-brand/5 px-5 py-3.5 font-semibold text-brand transition-all hover:bg-brand hover:text-white"
          >
            Preparar primeira sessão
            <Icon name="arrow-right" className="h-5 w-5" />
          </Link>

          <div className="mt-8 border-t border-muted-100 pt-6 dark:border-muted-800">
            <p className="text-center text-sm text-muted-500">
              Fez o pagamento pelo seu filho/a?
              <br />
              Envie-lhe o guia de preparação.
            </p>
            <div className="mt-3 flex gap-2">
              <button
                type="button"
                onClick={handleCopyLink}
                className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-muted-200 px-3 py-2 text-sm text-muted-600 transition-colors hover:bg-muted-50 dark:border-muted-700 dark:hover:bg-muted-800"
              >
                <Icon
                  name={copied ? "check" : "copy"}
                  className="h-4 w-4"
                />
                {copied ? "Copiado" : "Copiar link"}
              </button>
              <a
                href={`https://wa.me/?text=${encodeURIComponent(`Preparação para a primeira sessão de explicações: ${PREPARE_URL}`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-muted-200 px-3 py-2 text-sm text-muted-600 transition-colors hover:bg-muted-50 dark:border-muted-700 dark:hover:bg-muted-800"
              >
                <Icon name="chat-bubble" className="h-4 w-4" />
                WhatsApp
              </a>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-between border-t border-muted-100 pt-6 dark:border-muted-800">
            <div>
              <img
                src={signatureBlack}
                alt="Assinatura de André Casal"
                className="h-8 dark:hidden"
              />
              <img
                src={signatureWhite}
                alt="Assinatura de André Casal"
                className="hidden h-8 dark:block"
              />
            </div>
            <p className="text-sm text-muted-400">
              Ao teu sucesso <Icon name="rocket" className="inline h-4 w-4" />
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default Route;
